// UnitModuleTreeNode
// ***********************************************************************************************************************
import { Box, Checkbox, Grid, ListItemButton, Tooltip, Typography } from "@mui/material";
import * as React from "react";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { IUnitModuleNode } from "../../../../models/unit/unitModuleNode";
import { ListStateIconExpanded } from "../../../framework/List/ListStateIconExpanded";
import { ListStateIconHome } from "../../../framework/List/ListStateIconHome";
import { EllipsisTypography } from "../../../framework/Typography/EllipsisTypography";

export interface IUnitModuleTreeNodeProp {
    classes?: string;
    unitModuleNode: IUnitModuleNode;
    selectedId?: string;
    isFirstNode: boolean;
    oneModuleUnitsMode?: boolean;
    canEditWhistleBlowSettings: boolean;
    onClick: (id: string) => void;
    onDoubleClick: () => void;
    onSetUsage: (id: string, applicationPermissionType: ApplicationPermissionType, value: boolean) => void;
    onSetCollapsed: (id: string, value: boolean) => void;
}

export class UnitModuleTreeNode extends React.Component<IUnitModuleTreeNodeProp, {}> {
    handleUnitNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.unitModuleNode.id);
    };
    
    handleUnitNodeDoubleClick = (e) => {
        e.stopPropagation();
        this.props.onDoubleClick();
    };

    render() {
        const props = this.props;
        const unitModuleNode = props.unitModuleNode;
        if (!unitModuleNode || unitModuleNode.parent && (unitModuleNode.getAncesterIsCollapsed() || unitModuleNode.getIsHidden())) return null;
        const hasChildren = unitModuleNode.children.length > 0;
        const isRoot = unitModuleNode.getIsRoot();
        const usageIsDisabled = !unitModuleNode.getParentIsRoot();
        let selectedId = props.selectedId;
        if (!props.selectedId && isRoot) {
            selectedId = unitModuleNode.id;
        }
        return (
            <ListItemButton
                selected={selectedId === unitModuleNode.id}
                className={(!hasChildren ? " noChilds" : "") + (isRoot ? " root" : "") + (unitModuleNode.getIsDisabled() ? " disabled" : "") + (hasChildren && !unitModuleNode.collapsed ? " expanded" : "")}
                onClick={this.handleUnitNodeClick}
                onDoubleClick={this.handleUnitNodeDoubleClick}
                disableRipple
                sx={{ padding: "0 1rem" }}
            >
                <Grid container alignItems="center">
                    <Grid item sm={props.oneModuleUnitsMode ? 5 : 3}>
                        <Box display="flex" alignItems="center" sx={{ paddingLeft: (10 * unitModuleNode.level).toString(10) + "px" }}>
                            {(!isRoot && !props.isFirstNode) &&
                                <ListStateIconExpanded hasChildren={hasChildren} collapsed={unitModuleNode.collapsed} />
                            }
                            <ListStateIconHome />
                            <Typography fontWeight={selectedId === unitModuleNode.id ? 600 : 400} sx={{ marginLeft: ".5rem" }}>{unitModuleNode.name}</Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={props.oneModuleUnitsMode ? 5 : 3}>
                        <Tooltip title={unitModuleNode.comment}>
                            <span>
                                <EllipsisTypography fontWeight={selectedId === unitModuleNode.id ? 600 : 400}>{unitModuleNode.comment}</EllipsisTypography>
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid item sm={props.oneModuleUnitsMode ? 2 : 6}>
                        <Grid container>
                            {unitModuleNode.usages.filter(i => i.visible).map((usage) =>
                                <Grid item xs key={usage.applicationPermissionType}>
                                    {usage.enabled &&
                                    <Checkbox
                                        checked={usage.inUse}
                                        disabled={usageIsDisabled || usage.applicationPermissionType === ApplicationPermissionType.WhistleBlow && !props.canEditWhistleBlowSettings}
                                        onChange={(_e, checked: boolean) => props.onSetUsage(unitModuleNode.id, usage.applicationPermissionType, checked)}
                                    />
                                    }
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemButton>
        );
    }
}